var _circle, _circle2, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeexTag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 149,
    height: 149,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.5,
    r: 74.5,
    fill: "#010d16",
    opacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.5,
    cy: 74.502,
    r: 58.752,
    fill: "#010d16",
    opacity: 0.2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    x: 32,
    y: 33,
    fill: "#010d16",
    rx: 42
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f7f8f9",
    stroke: "#fff",
    d: "m59.912 63.69 11.32-6.548a5.54 5.54 0 0 1 5.515 0l11.337 6.545.001.001c1.7 1 2.75 2.803 2.768 4.782v13.056c0 1.98-1.05 3.8-2.747 4.779l-11.338 6.547h-.001a5.54 5.54 0 0 1-5.515.001l-11.336-6.546h-.002a5.56 5.56 0 0 1-2.749-4.78v-13.06c0-1.98 1.051-3.8 2.747-4.779zm6.972 16.927c-1.079 1.606.045 3.776 2 3.776h10.232c1.929 0 3.082-2.186 1.998-3.777C79.71 78.53 77.022 77.17 74 77.17c-3.024 0-5.712 1.36-7.116 3.447zm12.064-10.068A4.94 4.94 0 0 0 74 65.601a4.953 4.953 0 0 0-4.949 4.948A4.94 4.94 0 0 0 74 75.497a4.94 4.94 0 0 0 4.948-4.948z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeexTag);
export default __webpack_public_path__ + "static/media/deexTag.1d3705e3c7407e5c5697a7c95870fe7d.svg";
export { ForwardRef as ReactComponent };